/**
 * Portal Header Components - Shared Constants
 */

export const HEADER_DIMENSIONS = {
  DESKTOP_HEIGHT: 'h-20',
  MOBILE_HEIGHT: 'h-16',
} as const

export const BUTTON_SIZES = {
  DESKTOP: 'h-11 w-11',
  MOBILE: 'h-10 w-10',
} as const

export const ICON_SIZES = {
  DEFAULT: 'w-5 h-5',
  SMALL: 'w-4 h-4',
} as const

export const LANGUAGES = {
  EN: 'en',
  AR: 'ar',
  UR: 'ur',
} as const

export type LanguageCode = typeof LANGUAGES[keyof typeof LANGUAGES]

export const LANGUAGE_OPTIONS: { code: LanguageCode; label: string; nativeLabel: string }[] = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'ar', label: 'Arabic', nativeLabel: 'العربية' },
  { code: 'ur', label: 'Urdu', nativeLabel: 'اردو' },
]

// Legacy - kept for backwards compatibility
export const LANGUAGE_LABELS = {
  [LANGUAGES.EN]: 'العربية',
  [LANGUAGES.AR]: 'English',
  [LANGUAGES.UR]: 'English',
} as const
